export function isDOMText(data) {
  return typeof data === 'string';
}